import React, { useEffect, useState } from 'react';
import { Spinner, Table, Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import { useToast } from 'context/providers/ToastProvider';
import useToken from 'hooks/useToken';
import akasiaLogo from "assets/img/illustrations/akasia.png";
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';

const PagosLista = ({ filters, setID_Pago, setShowModalConciliar }) => {
    const { token } = useToken();
    const { showErrorToast } = useToast();

    const [pagos, setPagos] = useState([]);
    const [cargando, setCargando] = useState(true);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(15);
    const [totalRegistros, setTotalRegistros] = useState(0);

    useEffect(() => {
        if (filters.month && filters.year) {
            setPageNumber(1);
            ObtenerPagosList(1, pageSize);
        }
    }, [
        filters.month,
        filters.year,
        filters.idCatCuentaBancaria,
        filters.idCatMedioPago,
        filters.idVendedor,
        filters.filterValidados,
        filters.filterStatus
    ]);

    const handlePageChange = (page) => {
        setPageNumber(page);
        ObtenerPagosList(page, pageSize);
    };

    const handlePageSizeChange = (e) => {
        const size = parseInt(e.target.value);
        setPageSize(size);
        setPageNumber(1);
        ObtenerPagosList(1, size);
    };

    const ObtenerPagosList = async (page = 1, size = pageSize) => {
        setCargando(true);

        const url = `/api/AdministracionPagos/ObtenerPagosList/?month=${filters.month}&year=${filters.year}&idCatCuentaBancaria=${filters.idCatCuentaBancaria}&idMedioPago=${filters.idCatMedioPago}&idVendedor=${filters.idVendedor}&iValidado=${filters.filterValidados}&iEstatus=${filters.filterStatus}&pageNumber=${page}&pageSize=${size}`;

        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        }).catch((error) => {
            showErrorToast('' + error.message);
        });

        if (response && response.ok) {
            const objResponse = await response.json();
            if (objResponse.iResponseType == 1) {
                const data = JSON.parse(objResponse.detalles);
                const table2 = data['table2'] || data['Table2'] || [];
                const table3 = data['table3'] || data['Table3'] || [];

                setPagos(table2);

                if (table3.length > 0 && table3[0].TotalRegistros !== undefined) {
                    setTotalRegistros(table3[0].TotalRegistros);
                } else {
                    setTotalRegistros(0);
                }
            } else {
                showErrorToast(objResponse.vMessage);
            }
        }
        setCargando(false);
    };

    const columns = [
        {
            accessor: 'actions',
            Header: '',
            Cell: rowData => {
                const { idPago } = rowData.row.original;
                return (
                    <Link onClick={() => { setID_Pago(idPago); setShowModalConciliar(true) }} className="text-500 text-decoration-none" title="Ver detalles del pago">
                        <FontAwesomeIcon icon="eye" />
                    </Link>
                );
            },
            disableSortBy: true
        },
        {
            accessor: 'idPago',
            Header: 'ID',
            Cell: rowData => (
                <span className="text-dark">{rowData.row.original.idPago}</span>
            ),
            disableSortBy: true
        },
        {
            accessor: 'none',
            Header: 'Estatus',
            Cell: rowData => {
                const { bIsActive, bIsFacturado, idCatCuentaBancaria } = rowData.row.original;
                return (
                    <div className="d-flex align-items-center gap-1">
                        <img title={bIsActive == 1 ? "Activo" : "No Activo"} src={bIsActive == 1 ? "/img/activo.png" : "/img/noactivo.png"} alt="status" />
                        <img title={idCatCuentaBancaria > 0 ? "Validado" : "No Validado"} src={idCatCuentaBancaria > 0 ? "/img/activo.png" : "/img/noactivo.png"} alt="validado" />
                        <img title={bIsFacturado == 1 ? "Conciliado" : "No Conciliado"} src={bIsFacturado == 1 ? "/img/activo.png" : "/img/noactivo.png"} alt="conciliado" />
                    </div>
                );
            },
            disableSortBy: true
        },
        {
            accessor: 'idOrden',
            Header: 'Orden',
            Cell: rowData => {
                const { idOrden, vNombreCliente, bIsActive, bIsRecompra, bIsDistribucion } = rowData.row.original;
                return (
                    <div className="d-flex flex-column" style={{ maxWidth: '200px' }}>
                        <Link to={"/ordenes/detalle/" + idOrden} className={classNames("fw-bold text-truncate", { "text-danger": bIsActive == false })}>
                            #{idOrden}
                        </Link>
                        <span className={classNames("text-600 text-truncate", { "text-danger text-decoration-line-through": bIsActive == false })}>
                            {bIsDistribucion == null ? "" : bIsDistribucion == 1 ? "🎖️ " : bIsDistribucion == 0 ? <img width="12" src={akasiaLogo} alt="logo" className="me-1" /> : ""}
                            {bIsRecompra == 1 && "♻ "}
                            {vNombreCliente}
                        </span>
                    </div>
                );
            },
            disableSortBy: true
        },
        {
            accessor: 'dFechaPago',
            Header: 'Fecha Pago',
            Cell: rowData => (
                <span className="text-dark">
                    {rowData.row.original.dFechaPagoLargo}
                </span>
            )
        },
        {
            accessor: 'vUsuario',
            Header: 'Vendedor',
            Cell: rowData => (
                <span className="text-dark text-uppercase text-truncate d-inline-block" style={{ maxWidth: '80px' }}>
                    {rowData.row.original.vUsuario}
                </span>
            ),
            disableSortBy: true
        },
        {
            accessor: 'dImportePago',
            Header: 'Importe Pago',
            Cell: rowData => (
                <span className="fw-bold text-dark text-end d-block">
                    ${parseFloat(rowData.row.original.dImportePago).toLocaleString("es-MX", { maximumFractionDigits: 2, minimumFractionDigits: 2 })}
                </span>
            ),
            disableSortBy: true
        },
        {
            accessor: 'vMoneda',
            Header: 'Moneda',
            Cell: rowData => {
                const { vMoneda, dTipoCambio } = rowData.row.original;
                return (
                    <span className="text-500" style={{ fontSize: '0.8rem' }}>
                        {vMoneda} {vMoneda == "MXN" ? "" : " T.C. " + parseFloat(dTipoCambio).toFixed(4)}
                    </span>
                );
            },
            disableSortBy: true
        },
        {
            accessor: 'vReferencia',
            Header: 'Referencia',
            Cell: rowData => (
                rowData.row.original.vReferencia ?
                    <span className="text-primary fw-semi-bold text-truncate d-inline-block" style={{ maxWidth: '100px' }} title={rowData.row.original.vReferencia}>
                        {rowData.row.original.vReferencia}
                    </span>
                    : <span className="text-400">-</span>
            ),
            disableSortBy: true
        },
        {
            accessor: 'vMedioPago',
            Header: 'Medio de Pago',
            Cell: rowData => {
                const { vMedioPago } = rowData.row.original;
                return (
                    <div className="d-flex align-items-center gap-1 fw-semi-bold text-700">
                        {vMedioPago == 'EFECTIVO' && <img src="/img/efectivo20.png" alt="efectivo" width="16" />}
                        {vMedioPago == 'STRIPE' && <img src="/img/stripe30.png" alt="stripe" width="24" />}
                        {vMedioPago == 'PAYPAL' && <img src="/img/paypal20.png" alt="paypal" width="16" />}
                        {vMedioPago == 'BANCO' && <img src="/img/transferencia20.png" alt="banco" width="16" />}
                        <span className="text-truncate" style={{ maxWidth: '60px' }}>{vMedioPago}</span>
                    </div>
                );
            },
            disableSortBy: true
        },
        {
            accessor: 'vDescripcionFormaPago',
            Header: 'Forma de Pago',
            Cell: rowData => {
                const { vClave, vDescripcionFormaPago } = rowData.row.original;
                return (
                    <div className="d-flex align-items-center gap-1 fw-semi-bold text-600">
                        {vClave == '01' && <img src="/img/efectivo20.png" alt="fp" width="16" />}
                        {vClave == '03' && <img src="/img/transferencia20.png" alt="fp" width="16" />}
                        {vClave == '99' && <img src="/img/pordefinir20.png" alt="fp" width="16" />}
                        {vClave == '28' && <img src="/img/tarjeta20.png" alt="fp" width="16" />}
                        {vClave == '04' && <img src="/img/tarjeta20.png" alt="fp" width="16" />}
                        {vClave == '31' && <img src="/img/intermediario20.png" alt="fp" width="16" />}
                        <span className="text-truncate" style={{ maxWidth: '100px' }} title={`${vClave} - ${vDescripcionFormaPago}`}>
                            {vClave} - {vDescripcionFormaPago}
                        </span>
                    </div>
                );
            },
            disableSortBy: true
        }
    ];

    const totalPages = totalRegistros > 0 ? Math.ceil(totalRegistros / pageSize) : 0;

   

    return (
        <div className="bg-white rounded-4 shadow-sm border border-200 overflow-hidden">
            <AdvanceTableWrapper
                columns={columns}
                data={pagos}
                sortable
                pagination={true}
                perPage={100000}
            >
                <div className="d-flex justify-content-end align-items-center px-4 py-3 border-bottom border-200">
                    <div style={{ width: '300px' }}>
                        {!cargando && <AdvanceTableSearchBox table />}
                    </div>
                </div>

                <div className="p-0 position-relative" style={{ minHeight: '200px' }}>
                    <CustomTable table cargando={cargando} />
                </div>

                {(!cargando && totalRegistros > 0) && (
                    <div className="d-flex justify-content-between align-items-center px-4 py-4 border-top border-200 bg-white">
                        <div className="d-flex align-items-center">
                            <span className="fs--1 text-500 me-2">Mostrar</span>
                            <Form.Select size="sm" value={pageSize} onChange={handlePageSizeChange} className="w-auto me-2 border-300 shadow-none py-1" style={{ cursor: 'pointer', fontSize: '0.8rem' }}>
                                <option value={5}>5</option>
                                <option value={10}>10</option>
                                <option value={15}>15</option>
                                <option value={30}>30</option>
                                <option value={50}>50</option>
                            </Form.Select>
                            <span className="fs--1 text-500">
                                de {totalRegistros} registros en total
                            </span>
                        </div>
                        <div className="d-flex align-items-center justify-content-center gap-2">
                            <Button
                                size="sm"
                                variant="outline-secondary"
                                onClick={() => handlePageChange(pageNumber - 1)}
                                className={classNames('bg-white text-600 border-200', { disabled: pageNumber === 1 })}
                            >
                                Anterior
                            </Button>
                            <Button
                                size="sm"
                                variant="outline-secondary"
                                onClick={() => handlePageChange(pageNumber + 1)}
                                className={classNames('bg-white text-600 border-200', { disabled: pageNumber === totalPages || totalPages === 0 })}
                            >
                                Siguiente
                            </Button>
                        </div>
                    </div>
                )}
            </AdvanceTableWrapper>
        </div>
    );
};

PagosLista.propTypes = {
    filters: PropTypes.object.isRequired,
    setID_Pago: PropTypes.func.isRequired,
    setShowModalConciliar: PropTypes.func.isRequired
};

export default PagosLista;

const CustomTable = ({ getTableProps, headers, page, prepareRow, cargando }) => {
    return (
        <Table {...getTableProps()} hover responsive className="fs--1 mb-0 text-sans-serif border-bottom border-200">
            <thead className="bg-transparent text-dark text-uppercase align-middle" style={{ position: 'sticky', top: 0, zIndex: 1, fontSize: '0.65rem', letterSpacing: '0.02em' }}>
                <tr>
                    {headers.map((column, index) => (
                        <th
                            key={index}
                            {...column.getHeaderProps(column.getSortByToggleProps(column.headerProps))}
                            className={classNames('py-4 border-bottom border-200 fw-semi-bold', column.canSort && 'cursor-pointer', column.headerProps?.className)}
                        >
                            {column.render('Header')}
                            {column.canSort && (
                                <span className="ms-2">
                                    {column.isSorted ? (
                                        column.isSortedDesc ? (
                                            <FontAwesomeIcon icon="sort-down" className="text-primary" />
                                        ) : (
                                            <FontAwesomeIcon icon="sort-up" className="text-primary" />
                                        )
                                    ) : (
                                        <FontAwesomeIcon icon="sort" className="text-300" />
                                    )}
                                </span>
                            )}
                        </th>
                    ))}
                </tr>
            </thead>
            <tbody className="align-middle border-0">
                {cargando && page.length === 0 ? (
                    <tr>
                        <td colSpan={headers.length} className="text-center py-5">
                            <Spinner animation="border" variant="primary" />
                            <h5 className="mt-2 text-600">Cargando pagos...</h5>
                        </td>
                    </tr>
                ) : !cargando && page.length === 0 ? (
                    <tr>
                        <td colSpan={headers.length} className="text-center py-5">
                            <h5 className="text-500 mb-0">No se encontraron resultados</h5>
                        </td>
                    </tr>
                ) : (
                    page.map((row, i) => {
                        prepareRow(row);
                        return (
                            <tr key={i} {...row.getRowProps()} className="border-bottom border-200 hover-bg-100 bg-white">
                                {row.cells.map((cell, index) => (
                                    <td key={index} {...cell.getCellProps(cell.column.cellProps)} className="py-4 align-middle">
                                        {cell.render('Cell')}
                                    </td>
                                ))}
                            </tr>
                        );
                    })
                )}
            </tbody>
        </Table>
    );
};

CustomTable.propTypes = {
    getTableProps: PropTypes.func.isRequired,
    headers: PropTypes.array.isRequired,
    page: PropTypes.array.isRequired,
    prepareRow: PropTypes.func.isRequired,
    cargando: PropTypes.bool.isRequired
};
